import { fiCustomerType } from '../customer-billing-customer/customer-type';
import { fiPaymentMethodType } from '../payment-method-type';
import { BillingContactModel } from '../../billing/billing-contact.model';
import { BillingContactType } from '../../billing/billing-contact-type';
import { fiInvoiceMethodType } from '../customer-billing-invoice/invoice-method-type';
import { CustomerBillingInvoiceModel } from '../customer-billing-invoice/customer-billing-invoice.model';

export class CustomerBillingOtherCustomerModel {
    Id = undefined;
    BillingCustomerId = undefined;
    IsReseller = false;
    CustomerType = fiCustomerType.Other;
    Name = undefined;
    PaymentMethodType = fiPaymentMethodType.Invoice;
    DiscountGlobal = 0.0;
    ResellerId = undefined;
    ResellerExtraDiscount = 0.0;
    Description = undefined;
    ChargeVAT = true;
    VATNumber = { CountryCode: '', Number: '' };
    Address: {
        Street?: string;
        StreetExtra?: string;
        ZipCode?: string;
        City?: string;
        Country?: string;
    } = {};
    Contacts: BillingContactModel[] = [];
    InvoiceInfo: any;
    CurrentOtherInvoice: CustomerBillingInvoiceModel;

    DefaultResellerName = 'Chainformation';

    constructor(data?) {
        const contactToAdd = new BillingContactModel();
        contactToAdd.BillingContactType = BillingContactType.Contact;
        this.Contacts = [contactToAdd];

        const refToAdd = new BillingContactModel();
        refToAdd.BillingContactType = BillingContactType.Contact;
        this.InvoiceInfo = {
            ReceiverAddress: {},
            ReceiveTo: fiInvoiceMethodType.Email,
            BillingReference: [refToAdd],
        };

        if (data) {
            this.Initialize(data);
            this.CustomerType = data.IsReseller ? fiCustomerType.Reseller : fiCustomerType.Other;
        }
    }

    Initialize(data) {
        Object.assign(this, data);
    }

    private getValueOrEmptyString(val) {
        return val ? val : '';
    }

    FullAddress() {
        return String.format(
            '{0} {1} {2} {3} {4}',
            this.getValueOrEmptyString(this.Address.Street),
            this.getValueOrEmptyString(this.Address.StreetExtra),
            this.getValueOrEmptyString(this.Address.ZipCode),
            this.getValueOrEmptyString(this.Address.City),
            this.getValueOrEmptyString(this.Address.Country),
        );
    }
}
